import { useState, useEffect } from "react";
import { AlertCircleIcon } from "lucide-react";
import { getJobDetail } from "@service/job";
import { useParams } from "react-router-dom";
import { Job } from "@type/job";
import { SuggestionCandidateList } from "./employer-suggestion-candidates-list";

export function JobSuggestedCandidate() {
    const params = useParams()
    const [selectedJob, setSelectedJob] = useState<Job | null>(null);
    const [error, setError] = useState<string | null>(null);

    const loadApplications = async () => {
        try {
            setError(null);

            const jobDetail = await getJobDetail(params.jobid || "");
            if (jobDetail) {
                setSelectedJob(jobDetail);
            }
        } catch (err) {
            console.error(`Failed to fetch applicants for job:`, err);
            setError("Failed to load applicants. Please try again later.");
        }
    }

    useEffect(() => {
        loadApplications()
    }, [])

    return (
        <div className="space-y-4">
            {error && (
                <div className="bg-red-50 border border-red-200 text-red-700 p-4 rounded-lg flex items-center">
                    <AlertCircleIcon className="h-5 w-5 mr-2" />
                    {error}
                </div>
            )}

            <SuggestionCandidateList job={selectedJob} />
        </div>
    );
}